(function () {
  function initStickyAtc() {
    const sticky = document.querySelector('[data-noendy-sticky-atc]');
    if (!sticky) return;

    const sentinel = document.querySelector('.product-form__buttons, product-form .product-form__buttons, [data-product-form]');
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            sticky.classList.remove('is-visible');
          } else if (entry.boundingClientRect.top < 0) {
            sticky.classList.add('is-visible');
          } else {
            sticky.classList.remove('is-visible');
          }
        });
      },
      { rootMargin: '0px 0px -40% 0px', threshold: 0 }
    );
    observer.observe(sentinel);

    const cta = sticky.querySelector('[data-noendy-sticky-cta]');
    if (cta) {
      cta.addEventListener('click', () => {
        const target = document.querySelector('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
        if (target) {
          target.click();
        } else {
          const formCta = document.querySelector('.product-form__buttons button[type="submit"]');
          if (formCta) formCta.click();
        }
      });
    }
  }

  function initStockCounter() {
    document.querySelectorAll('[data-noendy-stock-counter]').forEach((el) => {
      const quantity = parseInt(el.dataset.inventory, 10);
      const threshold = parseInt(el.dataset.threshold, 10) || 10;
      const fullText = el.dataset.fullText || '';
      const lowText = el.dataset.lowText || '';

      if (Number.isFinite(quantity) && quantity > 0 && quantity <= threshold) {
        el.textContent = lowText.replace('{count}', quantity);
        el.classList.remove('noendy-stock-counter--ok');
        el.hidden = false;
      } else if (Number.isFinite(quantity) && quantity > threshold && fullText) {
        el.textContent = fullText;
        el.classList.add('noendy-stock-counter--ok');
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  function init() {
    initStickyAtc();
    initStockCounter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
